<template>
    <div>
        <b-button class="mb-2" variant="primary" v-b-modal.importExcelModel>
            Import Excel
        </b-button>

        <input ref="file" type="file" accept=".xlsx,.xls" class="d-none" @change="importExcel" />

        <b-modal id="importExcelModel" size="xl" v-model="viewImportExcelModel" title="Import Excel for Scores"
            hide-footer>
            <div>
                <!-- File input for Excel file -->
                <b-form-file v-if="!importExcelFile" v-model="importExcelFile" accept=".xlsx" size="sm"
                    @change="importExcel" placeholder="Choose an Excel file or drop it here..."
                    drop-placeholder="Drop file here...">
                </b-form-file>
                <!-- Display status message -->
                <span v-if="importExcelFile" class="text-danger">{{ excelImportStatus }}</span>
            </div>

            <div>
                <p style="font-size: 14px; font-weight: 600">Experiment Scores & Dates Excel Sheet</p>
                <h6 style="font-size: 14px; font-weight: 900">Note:</h6>
                <p><strong>1) Please do not include headings in the spreadsheet used to import data. Enter only the
                        values.</strong></p>
                <p style="color: red; font-weight: bold;">2)The column containing Total Marks (the total of experiment
                    parameters) should either be blank or contain a value. Irrespective of this, the total marks will be
                    calculated automatically.</p>
                <p style="color: red; font-weight: bold;">3) The Date should be in the DD/MM/YYYY format.</p>
                <br>

                <img src="@/assets/images/labscore.png" alt="Lab Score" class="img-fluid mx-auto d-block"
                    style="max-width: 100%; height: auto;" loading="lazy" />
                <br>
                <p>The imported data will look like this</p>
                <img src="@/assets/images/labscoreimportoutput.png" alt="Imported Data Output"
                    class="img-fluid mx-auto d-block" style="height: auto;" loading="lazy" />
            </div>
        </b-modal>
    </div>
</template>

<script>
import readXlsxFile from "read-excel-file";
import moment from "moment";

export default {
    props: {
        students: Array,
        headers: Array
    },
    data() {
        return {
            viewImportExcelModel: false,
            importExcelFile: null,
            excelImportStatus: "",
        }
    },

    methods: {
        async importExcel(event) {
            const input = event.target; // ✅ capture early

            try {
                const rows = await readXlsxFile(input.files[0]);

                if (!rows.length) throw new Error("Excel file is empty");

                if (rows.length > this.students.length) {
                    throw new Error("Row count exceeds students count");
                }

                const expectedCols = this.headers.length;
                if (rows.some(r => r.length !== expectedCols)) {
                    throw new Error("Column count mismatch");
                }

                const parsed = [];

                rows.forEach((row, rowIndex) => {
                    const student = this.students[rowIndex];

                    row.forEach((value, colIndex) => {
                        const header = this.headers[colIndex];

                        if (header.type === "date") {
                            if (!value) return;

                            const date = moment(value, "DD/MM/YYYY", true);
                            if (!date.isValid()) {
                                throw new Error(`Invalid date at row ${rowIndex + 1}`);
                            }

                            parsed.push({
                                student_id: student.institution_user_id,
                                experiment_id: header.experiment_id,
                                type: "date",
                                value: date.format("YYYY-MM-DD")
                            });
                        } else if (header.type === null) {
                            if (isNaN(value)) {
                                throw new Error(`Invalid score at row ${rowIndex + 1}`);
                            }

                            parsed.push({
                                student_id: student.institution_user_id,
                                experiment_id: header.experiment_id,
                                header_id: header.id,
                                type: "score",
                                value: parseFloat(value)
                            });
                        }
                    });
                });

                this.$emit("imported", parsed);
                this.$toast.success("Excel imported successfully");

            } catch (e) {
                this.$toast.error(e.message);
            } finally {
                input.value = ""; // ✅ ESLint safe

                // Reset file input and status
                this.excelImportStatus = "";
                this.importExcelFile = null;
                this.viewImportExcelModel = false;
            }
        }

    }
};
</script>
